<template>
  <ul class="submenu">
    <li v-for="item in columnData.children" :key="item.uid">
      <span @click="loadingArticle(item.uid, 1)" class="classfy">
        {{ item.text }}
      </span>
      <template v-for="(itemLevel, indexLevel) in columnLevelFilterData">
        <template v-if="itemLevel.children != item.children">
          <span :key="indexLevel" class="link_icon" v-if="item.children.length">
            <img src="./images/arrow_right.png" />
          </span>
        </template>
      </template>
      <template v-if="item.children">
        <!-- 四级不显示 -->
        <template v-for="(itemLevel, indexLevel) in columnLevelFilterData">
          <ListColumn
            :key="indexLevel"
            v-if="itemLevel.children != item.children"
            :columnData="item"
          ></ListColumn>
        </template>
        <!-- <ListColumn :columnData="item"></ListColumn> -->
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ListColumn",
  data() {
    return {};
  },
  props: {
    columnData: Object,
    columnLevelFilterData: Array,
    loadingArticle:Function,
  },
};
</script>

<style lang="less" scoped>
div {
  .submenu {
    padding-right: 10px;
    background-color: #fff;
    border-left: #e7e7e7 1px solid;
    border-right: #e7e7e7 1px solid;
    li {
      padding: 6px 0 6px 40px;
      border-top: 1px dotted #d5d5d5;
      background-color: #fff;
      line-height: 130%;
      position: relative;
      .link_icon {
        /* padding-left: 70px; */
        position: absolute;
        right: 6px;
        top: 6px;
      }
      .classfy {
        color: #000;
        font-size: 15px;
        font-family: "微软雅黑";
        cursor: pointer;
      }
    }
  }
}
</style>